module.exports = __webpack_public_path__ + "nl-download-294c9e.webp";